import type { AxiosError } from 'axios';
import axios from 'axios';

function isAxiosError<ResponseType = unknown>(error: unknown): error is AxiosError<ResponseType> {
  return Boolean(error) && axios.isAxiosError(error);
}

export { isAxiosError };
